var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('svg',{staticClass:"spinner__svg"},[_c('circle',{attrs:{"cx":"15","cy":"15","r":"13"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }